var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useAnalyticsContext } from 'src/common/metrics';
import { transformPaymentSelectionOutput } from 'src/utils/paymentSelectionUtils';
import { HandshakePainterServiceApiV1 } from '../api/handshakeApi';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Hook to get payment selection.
 */
export const usePaymentSelection = () => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['paymentSelection', defaultApiParams.marketplaceId, defaultApiParams.xUserLinked],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return yield HandshakePainterServiceApiV1.findPaymentMethods({
                xUserLinked: defaultApiParams.xUserLinked,
                marketplaceId: defaultApiParams.marketplaceId,
            });
        }),
        select: (data) => transformPaymentSelectionOutput(rumClient, data),
        // This is used to ensure payment methods are updated when users add new cards.
        // Do not change.
        refetchOnWindowFocus: true,
    });
};
